// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { createEmptyPipeline as tspCreateEmptyPipeline } from "@typespec/ts-http-runtime";
/**
 * Creates a totally empty pipeline.
 * Useful for testing or creating a custom one.
 */
export function createEmptyPipeline() {
    return tspCreateEmptyPipeline();
}
